import React from 'react';

import { Stack } from './Stack';

export interface DebugJsonProps {
  value: unknown;
}

/**
 * A useful Dev component when developing a UI to be able to quickly
 * visualize data before properly wiring it up into a proper format
 */
export const DebugJson: React.FC<DebugJsonProps> = ({ value }) => {
  return (
    <Stack
      align="start"
      className="mb-4 overflow-auto rounded-lg border p-3 text-sm"
      gap={2}
      direction="horizontal"
    >
      <pre>{JSON.stringify(value, null, 2)}</pre>
    </Stack>
  );
};
